import localePt from '@angular/common/locales/pt';
import { CommonModule, CurrencyPipe, registerLocaleData  } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { ComumModule } from '../../../shared/comum.module';
import { RelatorioVendasFiltroComponent } from './relatorio-vendas-filtro/relatorio-vendas-filtro.component';
import { RelatorioVendasListaComponent } from './relatorio-vendas-lista/relatorio-vendas-lista.component';
import { RelatorioVendasService } from './relatorio-vendas-service/relatorio-vendas.service';
import { RelatorioVendasComponent } from './relatorio-vendas.component';

registerLocaleData(localePt, 'pt');

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    NgbModule,
    BrowserModule,
    BrowserAnimationsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    HttpClientModule,
    FormsModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    HttpClientModule,
    TreeTableModule
  ],
  exports: [
    RelatorioVendasComponent
  ],
  providers: [
    RelatorioVendasService,
    CurrencyPipe,
    {
      provide: LOCALE_ID,
      useValue: 'pt'
    }
  ],
  declarations: [
    RelatorioVendasComponent,
    RelatorioVendasListaComponent,
    RelatorioVendasFiltroComponent,
  ]
})
export class RelatorioVendasModule { }
{ }
